import React from "react";
import { styled } from "@mui/material";
import Avatar from "../../Avatar";
import { AvatarProps } from "../../Avatar/Avatar";

const StyledSectionHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
`;

interface SectionHeaderProps {
  title: string;
  avatarSrc?: string;
  avatarVariant?: AvatarProps["variant"];
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  avatarSrc,
  avatarVariant = "circular",
}) => {
  if (!avatarSrc) {
    return <span>{title}</span>;
  }

  return (
    <StyledSectionHeader>
      <Avatar
        src={avatarSrc}
        alt={title}
        size="xs"
        variant={avatarVariant}
        type="player"
      />
      <span>{title}</span>
    </StyledSectionHeader>
  );
};

export default SectionHeader;
